type PoolWizardMode = "create" | "edit";

type PoolWizardSubmitTarget =
  | { action: "create"; poolCode: null }
  | { action: "update"; poolCode: string };

function normalizePoolCode(poolCode: string | null | undefined): string | null {
  const normalized = poolCode?.trim();
  return normalized ? normalized : null;
}

export function resolvePoolWizardSubmitTarget({
  mode,
  poolCode,
}: {
  mode: PoolWizardMode;
  poolCode?: string | null;
}): PoolWizardSubmitTarget {
  const normalizedPoolCode = normalizePoolCode(poolCode);
  if (mode === "edit" || normalizedPoolCode) {
    if (!normalizedPoolCode) {
      throw new Error("Pool code is required to update a pool.");
    }
    return { action: "update", poolCode: normalizedPoolCode };
  }

  return { action: "create", poolCode: null };
}
